import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, LinearProgress, Paper, Typography } from "@material-ui/core";
import { formatDate } from "../../../common/formatDate";
import CloseIcon from '@material-ui/icons/Close';
import { useRef, useState } from "react";
import { useVerifyCalibration } from "../stressEntry/stressEntryQueries";
import { toast } from "react-toastify";
import { useFetchContext } from "../../../common/FetchContext";
import { useAssetsView } from "../../../intake/intakeQueries";
import { Line } from "@nivo/line";
import React from "react";
import { usePostFile } from "../../../common/services/fileServices";
import Delete from "@material-ui/icons/Delete";


export const VerifyCalibrationDialog = ({ open, onClose, assetID, onUpdated }: any) => {

    const fileInputRef = useRef<HTMLInputElement>(null);
    const [files, setFiles] = React.useState([]);
    const { mutateAsync: mutatePostFile } = usePostFile();


    const { isLoading: isverifyassetLoading,
        isSuccess,
        isError,
        data, } = useAssetsView(assetID);
    const { authAxios } = useFetchContext();

    const [approved, setApproved] = useState<boolean | null>(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const { mutateAsync: verifyCalibration, isLoading } = useVerifyCalibration();

    const handleFileUpload = async (item: any) => {
        console.log(item)
        fileInputRef.current?.click()
    };

    const handleFilePicked = (event: React.ChangeEvent<HTMLInputElement>) => {
        const uploadedFiles = event.target.files;
        if (uploadedFiles) {
            setFiles(uploadedFiles as any);
        }

    };

    const handleSubmit = async () => {
        if (approved === null) return;

        try {

            if (files.length > 0) {
                for (let file of files) {
                    const postedFile = await mutatePostFile({ authAxios, file });

                    await verifyCalibration({
                        authAxios,
                        asset_id: assetID,
                        status: approved ? "approved" : "reject",
                        azure_file: postedFile.url,
                    });

                    toast.success(
                        approved ? "Calibration approved" : "Calibration rejected"
                    );

                    onUpdated();
                    setConfirmOpen(false);
                    onClose();
                    setApproved(null);
                }
            } else {

                await verifyCalibration({
                    authAxios,
                    asset_id: assetID,
                    status: approved ? "approved" : "reject",
                });

                toast.success(
                    approved ? "Calibration approved" : "Calibration rejected"
                );

                onUpdated();
                setConfirmOpen(false);
                onClose();
                setApproved(null);
            }



        } catch {
            toast.error("Verification failed");
        }
    };

    const openConfirm = (value: boolean) => {
        setApproved(value);
        setConfirmOpen(true);
    };




    return (

        <>
            <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
                <DialogTitle>
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Typography variant="h6">Verify Calibration</Typography>
                        <IconButton onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </DialogTitle>

                <Divider />

                <DialogContent dividers>
                    {
                        isverifyassetLoading ? <LinearProgress /> : (
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography>
                                        <b>Asset:</b> {data?.asset_name || "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography>
                                        <b>Calibration Date:</b>{" "}
                                        {data?.requested_last_calibrated_date
                                            ? formatDate(data.requested_last_calibrated_date)
                                            : "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography>
                                        <b>Calibrated By:</b> {data?.calibrated_by || "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography>
                                        <b>Submitted On:</b>{" "}
                                        {data?.last_action_datetime
                                            ? formatDate(data.last_action_datetime)
                                            : "N/A"}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography><b>Note:</b></Typography>
                                    <Paper style={{ padding: 10, marginTop: 5 }}>
                                        {data?.notes || "N/A"}
                                    </Paper>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="h5" color="primary" >Upload Calibration Report  <img onClick={handleFileUpload} src="/file_upload.svg" alt="Custom Icon" width="30" height="30"   /></Typography>
                                </Grid>

                                <Grid item xs={4}>

                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        style={{ display: 'none' }}
                                        // accept="image/*,.pdf"
                                        onChange={handleFilePicked}
                                    />
                                    {files.length != 0 && <div style={{ position: "relative", display: "inline-block" }}>
                                        <img src="/file_icon.png" alt="Custom Icon" height={100} width={100} />
                                        <IconButton
                                            style={{
                                                position: "absolute",
                                                top: "5px",
                                                right: "5px",
                                                background: "lightgray",
                                                color: "black",
                                                border: "none",
                                                borderRadius: "50%",
                                                width: "20px",
                                                height: "20px",
                                            }}
                                            onClick={() => setFiles([])}
                                        >
                                            <Delete></Delete></IconButton>
                                    </div>}
                                </Grid>
                            </Grid>

                        )

                    }

                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => openConfirm(false)}
                        color="secondary"
                        variant="outlined"
                        disabled={isLoading}
                    >
                        Reject
                    </Button>

                    <Button
                        onClick={() => openConfirm(true)}
                        color="primary"
                        variant="contained"
                        disabled={isLoading}
                    >
                        Approve
                    </Button>
                </DialogActions>

            </Dialog>

            <Dialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>
                    {approved ? "Confirm Approval" : "Confirm Rejection"}
                </DialogTitle>

                <DialogContent>
                    <Typography>
                        Are you sure you want to{" "}
                        <b>{approved ? "approve" : "reject"}</b> this calibration?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => setConfirmOpen(false)}
                        variant="outlined"
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={handleSubmit}
                        color="primary"
                        variant="contained"
                        disabled={isLoading}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>

    );
};
